import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  InputLabel, MenuItem,
  Radio,
  RadioGroup, Select,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import {grey} from "@mui/material/colors";
import React, {useEffect, useState} from "react";

const VarType = {
  CONST: "CONST",
  TRANSFER: "TRANSFER"
}

const initParam = {
  source_scope: "const",
  source: "",
  target_scope: "flow",
  scope: "flow",
  target: ""
}

export const VarForm = ({selectedParam, isForm, project, handleClose, onSubmit, onDelete}) => {
  const [type, setType] = useState(VarType.CONST);
  const [param, setParam] = useState({...initParam})

  useEffect(() => {
    if (selectedParam) {
      setType(selectedParam?.source_scope === "const" ? VarType.CONST : VarType.TRANSFER)
      setParam(selectedParam);
    } else {
      setParam({...initParam})
    }
  }, [selectedParam]);

  useEffect(() => {
    setParam(prev => ({...prev, source_scope: type === VarType.TRANSFER ? "flow" : "const"}))
  }, [type])

  const onClose = () => {
    setParam({...initParam})
    setType(VarType.CONST);
    handleClose();
  }

  return (
    <>
      <Typography>Target</Typography>
      <Stack direction={"row"} gap={1}>
        <ScopeSelect
          value={param?.target_scope}
          onChange={(e) => {
            setParam(prev => {
              const params = {...prev};
              params.target_scope = e.target.value
              params.scope = e.target.value
              return params;
            })
          }}
          name={"target_scope"}
          isForm={isForm}
        />
        <TextField
          size={"small"}
          label={"Target"}
          sx={{flex: 1}}
          value={param?.target || ""}
          onChange={(e) => {
            setParam(prev => {
              const params = {...prev};
              params.target = e.target.value
              return params;
            })
          }}
        />
      </Stack>
      <RadioGroup
        defaultValue="female"
        aria-labelledby="demo-customized-radios"
        name="customized-radios"
        row
        value={type}
        onChange={(e, newValue) => setType(newValue)}
      >
        <FormControlLabel value={VarType.CONST} control={<Radio/>}
                          label={<><Typography fontWeight={600}>Constant</Typography><Typography variant={"body2"}
                                                                                                 fontSize={11}
                                                                                                 color={grey[600]}>Set
                            Variable from constants</Typography></>}/>
        <FormControlLabel value={VarType.TRANSFER} control={<Radio/>}
                          label={<><Typography fontWeight={600}>Transfer</Typography><Typography variant={"body2"}
                                                                                                 fontSize={11}
                                                                                                 color={grey[600]}>Transfer
                            variable from one scope to another</Typography></>}/>
      </RadioGroup>
      {
        type === VarType.TRANSFER ?
          <Stack direction={"row"} gap={1}>
            <ScopeSelect
              value={param?.source_scope}
              onChange={(e) => {
                setParam(prev => {
                  const params = {...prev};
                  params.source_scope = e.target.value
                  return params;
                })
              }}
              name={"source_scope"}
              isForm={isForm}
            />
            <TextField
              size={"small"}
              label={"Source"}
              sx={{flex: 1}}
              value={param?.source || ""}
              onChange={(e) => {
                setParam(prev => {
                  const params = {...prev};
                  params.source = e.target.value
                  return params;
                })
              }}
            />
          </Stack>
          : <FormControl size={"small"} sx={{flex: 1}}>
            <InputLabel id={`constant-label`} sx={{textTransform: "capitalize"}}>Constants</InputLabel>
            <Select
              labelId={`constant-label`}
              size={"small"}
              label={"Constants"}
              value={param?.source}
              onChange={(e) => {
                setParam(prev => {
                  const params = {...prev};
                  params.source = e.target.value
                  return params;
                })
              }}
            >
              {
                project?.constants &&
                Object?.entries(project?.constants)?.map(([key, value]) => {
                  return <MenuItem key={key} value={key}>{key} - {value}</MenuItem>
                })
              }
            </Select>
          </FormControl>
      }

      <Stack direction={"row"} gap={1} justifyContent={"space-between"}>
        <Box>
          {
            selectedParam && <Button
              variant={"outlined"}
              color={"error"}
              sx={{borderRadius: 0, textTransform: "capitalize", ml: "auto"}}
              onClick={onDelete}
            >
              Delete
            </Button>
          }
        </Box>
        <Stack direction={"row"} gap={1} justifyContent={"flex-start"}>
          <Button
            variant={"contained"}
            color={"secondary"}
            sx={{borderRadius: 0, textTransform: "capitalize"}}
            disabled={!param?.source || !param?.target}
            onClick={() => onSubmit(param)}
          >
            Save
          </Button>
          <Button
            variant={"outlined"}
            color={"secondary"}
            sx={{borderRadius: 0, textTransform: "capitalize"}}
            onClick={onClose}
          >
            Cancel
          </Button>
        </Stack>
      </Stack>
    </>
  )
}


const ScopeSelect = ({value, onChange, isForm = false, name}) => {

  return (
    <FormControl size={"small"} sx={{flex: 1}}>
      <InputLabel id={`${name}-target-label`} sx={{textTransform: "capitalize"}}>Scope</InputLabel>
      <Select
        labelId={`${name}-target-label`}
        size={"small"} name={name}
        label={"Scope"}
        value={value}
        onChange={onChange}
      >
        {isForm && <MenuItem value={"form"}>Form</MenuItem>}
        <MenuItem value={"flow"}>Flow</MenuItem>
        <MenuItem value={"global"}>Global</MenuItem>
      </Select>
    </FormControl>
  )
}